// Webpack Imports
import 'bootstrap';
import 'slick-carousel';
import AOS from 'aos'  ;

( function ( $) {
	'use strict';

  // Create a Filter: https://codepen.io/terf/post/jquery-filter-divs
  var $btns = $( '.filter button' ).on( 'click', function ( e ) {
    e.preventDefault();
    $btns.removeClass( 'active' );
    $( this ).addClass( 'active' );
    history.replaceState(undefined, undefined, '#' + $( this ).attr('id').substring(5));
    $( '#filter .card' ).addClass( 'd-none' ).removeClass( 'aos-init aos-animate ml-auto' ).removeAttr( 'data-aos' );
    AOS.refresh();
    if ( this.id == 'all' ) {
      $( '#filter .card' ).removeClass( 'd-none aos-init aos-animate' ).attr( 'data-aos', 'fade-up' );
    } else {
      $( '#filter .card.' + this.id ).removeClass( 'd-none aos-animate' ).attr( 'data-aos', 'fade-up' );
    }

    $( '#filter .card:not(".d-none"):odd' ).removeClass( 'even' ).addClass( 'odd' );
    $( '#filter .card:not(".d-none"):even' ).removeClass( 'odd' ).addClass( 'even' );
    AOS.refresh();
  } );

  $( '#filter .card:odd' ).addClass( 'odd' );
  $( '#filter .card:even' ).addClass( 'even' );

  AOS.init( {
    easing: 'ease-out-back',
  } );

  if(window.location.hash) {
    $('#work-' + window.location.hash.substring(1)).trigger('click');
  }

	// Slick Carousel
	$( '.slick-carousel--main').each(function() {
	  var carousel = $(this).children('.slick').children('.slick-carousel');
	  var carousel_nav = $(this).find('.slick-carousel--nav > .slick > .slick-carousel');
    carousel.slick( {
      infinite: true,
      variableWidth: true,
      dots: false,
      arrows: false,
      focusOnSelect: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      asNavFor: carousel_nav,
    } );
    carousel_nav.slick( {
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: carousel,
      variableWidth: true,
      dots: false,
      centerMode: true,
      focusOnSelect: true
    });
  });
	$( document ).on( 'click', '.slick-carousel .slick-slide', function () {
		var i = $( this ).data( 'slick-index' );
		$( this ).closest( '.slick-carousel' ).slick( 'slickGoTo', i );
	} );
}( jQuery ) );
